// @ts-check
import { defineConfig } from '../utils';

export function palletizingPoints() {
  return defineConfig({
    properties: {
      'PuntosPaletizado.CampoOrdenacionPuntosPaletizado': {
        /** @type {'Id' | 'Codigo' | 'Nombre'} */
        defaultValue: 'Id',
      },
    },
  });
}
